import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { baseVariables } from '@marriott/mi-ui-library';

export const Styled = styled.div`
  ${rtl`
  .image-gallery-component {
    height: ${toRem(288)};
    // width: ${toRem(512)};
    width: auto;// changed to auto to fix chat-renderer layout issue

    .glide__slide {
      width: ${toRem(512)} !important;
    }

    &.map-view-enabled {
      height: auto;
      height: ${toRem(222)};
      width: ${toRem(333)} !important;

      .glide__slide {
        width: ${toRem(333)} !important;
      }

      .glide-wrap .property-image .property-image--img {
        width: 100%;
        height: ${toRem(222)};
      }
    }

    .no-image-div {
      display: flex;
      align-items: center;
      justify-content: center;
      align-content: center;
      .hqv-modal-opener {
        background: transparent;
      }
      div{
        &:before{
          font-size: ${toRem(30)} !important;
        }
      }
    }
    .glide-wrap {
      width: 100%;
      margin: 0 auto;
      // additional here.
      .additional-components {
        .ribbons-container {
          position: absolute;
          min-width: ${toRem(220)};
          .logo-container {
            font-size: ${toRem(18)};
          }
          .ribbon {
            cursor: default;
            z-index: 1;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            background-color: ${theme.color['peach-orange']};
            border-radius: ${toRem(4)};
            position: absolute;
            left: ${toRem(17)};
            top: ${toRem(17)};
            padding: ${toRem(6)} ${toRem(8)};
            font-weight: ${theme.fonts['fontWeightMedium']};
            letter-spacing: ${toRem(1.3)};
          }
        }
      }
      .carousel {
        position: relative;
        .property-image {
          height: 100%;
          width: 100%;
        }
        .unavailable-image-fallback {
          position: relative;
          .image-unavailable-text {
            position: absolute;
            top: 50%;
            left: 38%;
          }
        }
        .carousel__back-button, .carousel__next-button {
          width: ${toRem(40)};
          height: ${toRem(40)};
          position: absolute;
          top: calc(50% - ${toRem(40)}/2);
          border-radius: 50%;
          border-color: transparent;
          // background-color: ${theme.color['gray']}54; // Gray background button
          background-color: ${theme.color['white']}60; // White background button
          box-shadow: 0 6px 26px 0 rgba(0,0,0,0.07);
          font-size: ${toRem(24)};
          padding: 0;
          z-index: 1;
          // color:  ${theme.color['white']}; // Gray background button
          color:  ${theme.color['black']}54; // White background button
          &:focus {
            outline: transparent;
          }
          .icon-arrow-right, .icon-arrow-left {
            &:before {
              color:  ${theme.color['white']};
            }
          }
          &:active, &:hover {
            // background-color: ${theme.color['gray']}80; // Gray background button
            background-color: ${theme.color['white']};
            // opacity: 1;
            color:  ${theme.color['black']}; // White background button
            .icon-arrow-right, .icon-arrow-left {
              &:before {
                color:  ${theme.color['black']};
              }
            }
          }
        }
        .carousel__next-button {
          right: ${toRem(16)};
          bottom: 0;
        }
        .carousel__next-button:focus-visible:not(:active){
          outline: -webkit-focus-ring-color auto 1px;
        }
        .carousel__next-button: focus{
         outline:none;
        }
        .carousel__back-button {
          left: ${toRem(16)};
          bottom: 0;
        }
        .carousel__back-button:focus-visible:not(:active){
          outline: -webkit-focus-ring-color auto 1px;
        }
        .carousel__back-button: focus{
         outline:none;
        }
      }
    .property-image {
      position: relative;
      .scrim-component {
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0.47) 43.68%,
          rgba(0, 0, 0, 0.62) 100%
        );
        height: ${toRem(116)};
        position: absolute;
        bottom: 0;
        width: 100%;
        @media only ${baseVariables.mediaQuery.md} {
          border-radius: 0 0 0 ${toRem(14)};
        }
        @media only ${baseVariables.mediaQuery.lg} {
          border-radius: 0;
        }
        cursor: default;
      }
      .property-image--img {
        cursor: default;
        width: 100%;
        border-radius: 0 0 ${toRem(14)} ${toRem(14)};
      }
    }
  }

  .glide {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    .glide__track {
      overflow: hidden;
      width: 100%;
      /* border-radius: ${toRem(14)} 0 0 ${toRem(14)}; */
      // .glide__slides {
      //   position: relative;
      //   overflow: hidden;
      //   display: flex;
      //   width: ${toRem(504)};
      //   padding: 0;
      //   margin: 0;
      //   list-style-type: none;
      // }
    }
    .arrows-container {
      cursor: default;
      .carouselControlType1{
        height: 0;
      }
      .glide__arrow {
        width: ${toRem(40)};
        height: ${toRem(40)};
        top: 50%;
        border-radius: 50%;
        border-color: transparent;
        opacity: 0.6;
        font-size: ${toRem(24)};
        padding: 0;
        z-index: 1;
        &:focus {
          outline: transparent;
        }
        &:hover {
          opacity: 1;
        }
        &:focus {
          opacity: 1;

          .icon-arrow-right {
            &:before {
              color: ${theme.color['black']};
            }
          }

          .icon-arrow-left {
            &:before {
              color: ${theme.color['black']};
            }
          }
        }
        &.glide__arrow--right {
          right: ${toRem(16)};
          bottom: 0;
        }
        &.glide__arrow--left {
          left: ${toRem(16)};
          bottom: 0;
        }
      }
    }
    .glide__bullets {
      position: absolute;
      bottom: ${toRem(8)};
      right: ${toRem(16)};
      left: auto;
      transform: none;
      opacity: 0.5;
      padding: ${toRem(5)};
      border-radius: ${toRem(13)};
      display: flex;
      align-items: center;
      justify-content: center;
      height: ${toRem(26)};
      width: ${toRem(88)};
      z-index: 1;
      cursor: default;
    }
    .glide__bullet{
      background-color:${theme.color['white']};
    }
    .glide__bullets .glide__bullet {
      height: ${toRem(4)};
      width: ${toRem(4)};
      border-radius: 100%;
      margin: 0 ${toRem(5)};
      border: ${toRem(1)} solid transparent;
      cursor: default;
      opacity: 1;
    }
    .glide__bullets .glide__bullet.glide__bullet--active {
      height: ${toRem(6)};
      width: ${toRem(6)};
      &::after {
        content: none;
      }
    }
  }
  }


  .map-view-enabled {
    height: ${toRem(240)};
    width: ${toRem(360)};
    .glide-wrap {
      width: 100%;
      margin: 0 auto;

      .glide {
        .property-image {
          position: relative;
          .scrim-component {
            height: ${toRem(110)};
            border-radius: 0;
          }
          .property-image--img {
            height: ${toRem(240)};
            /* border-radius: ${toRem(14)} ${toRem(14)} 0 0; */
            width: ${toRem(360)};
          }
        }
      }
    }
  }
  @media only ${theme.mediaQuery.tabletMax} {
    .image-gallery-component {
      width: 100%;
    }
  }
  @media only ${theme.mediaQuery.allTablets} {
    .image-gallery-component {
      height: ${toRem(240)};
      width: ${toRem(360)};

      .glide-wrap {
        width: 100%;
        margin: 0 auto;
        .glide {
          .glide__track {
            overflow: hidden;
            width: 100%;
            .glide__slides {
              position: relative;
              overflow: hidden;
              display: flex;
              width: ${toRem(320)};
              padding: 0;
              margin: 0;
              list-style-type: none;
            }
          }
          .property-image {
            height: ${toRem(214)};
            .scrim-component {
              height: ${toRem(120)};
            }
            .property-image--img {
              height: ${toRem(214)};
              width: ${toRem(320)};
            }
          }
          .glide__arrow.glide__arrow--right {
            right: ${toRem(8)};
          }
          .glide__arrow.glide__arrow--left {
            left: ${toRem(8)};
          }
          .glide__slide {
            width: ${toRem(320)} !important;
          }
        }
      }
    }
  }
  @media only ${theme.mediaQuery.allMobiles} {
    .image-gallery-component {
      height: ${toRem(240)};
      width: 100%;
      .no-image-div{
        height: ${toRem(220)};
      }
      .glide-wrap {
        width: 100%;
        margin: 0 auto;
        .glide {
          .glide__slide {
            width: auto !important;
          }
          .property-image {
            position: relative;
            .scrim-component {
              height: ${toRem(110)};
              border-radius: 0;
            }
            .property-image--img {
              height: ${toRem(220)};
              /* border-radius: ${toRem(14)} ${toRem(14)} 0 0; */
              width: calc(100vw - ${toRem(32)});
            }
          }
        }
      }
    }
  }
  `}
`;
